import { render, staticRenderFns } from "./AttributeValueList.vue?vue&type=template&id=591d423a&"
import script from "./AttributeValueList.vue?vue&type=script&lang=ts&"
export * from "./AttributeValueList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports